import { Component } from "react";
import { connect } from 'react-redux';
import axios from "axios";
import './FAQ.scss';
import BuyerFAQFolderList from './BuyerFAQFolderList';
import { getBuyerHeaders, getBuyerUrl } from "shared/http";
import { buyerJiraConfluenceFolderList, buyerJiraConfluencePageList, buyerJiraConfluenceSearchPageView } from "shared/settings/apiconfig";
import { NoData } from "features/components/redirect/NoData";
import { Button } from "react-bootstrap";

const FAQ_FOLDER_TITLE_STORAGE_KEY = 'buyerFaqSelectedFolderTitles';
const FAQ_BASE_PATH = '/help-center/buyer';

class buyerFaq extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pageLoading: false,
            searchLoading: false,
            folders: [],
            pages: [],
            selectedFolderTitle: '',
            pageError: '',
            searchValue: '',
            errorpageredirect: false,
            errorType: ''
        };
        this.buyrId = this.props.user.id;
    }

    componentDidMount() {
        const folderId = this.getFolderId();

        if (folderId) {
            if (!this.loadFolderState(folderId)) {
                this.loadPages();
            }
            return;
        }

        this.loadFolders();
    }

    componentDidUpdate(prevProps) {
        const prevFolderId = this.getFolderId(prevProps);
        const currentFolderId = this.getFolderId();

        if (prevFolderId !== currentFolderId) {
            if (currentFolderId) {
                if (!this.loadFolderState(currentFolderId)) {
                    this.loadPages();
                }
            } else {
                this.loadFolders();
            }
            return;
        }

        if (currentFolderId && prevProps.location.state !== this.props.location.state) {
            if (!this.loadFolderState(currentFolderId)) {
                this.loadPages();
            }
        }
    }

    getFolderId = (props = this.props) => props.match?.params?.folderid || '';

    setApiError = (error, fallbackMessage) => {
        const status = error?.response?.status;

        if (status === 401 || status === 404) {
            this.setState({
                errorpageredirect: true,
                errorType: status === 401 ? 'expiryError' : 'noData',
                pageLoading: false,
                searchLoading: false
            });
            return;
        }

        this.setState({
            pageError: fallbackMessage,
            pageLoading: false,
            searchLoading: false
        });
    }

    loadFolderState = (folderId) => {
        const routeState = this.props.location.state || {};
        const pageState = routeState.pages !== undefined ? routeState : null;

        if (!pageState || !Array.isArray(pageState.pages)) {
            return false;
        }

        this.setState({
            pages: pageState.pages,
            selectedFolderTitle: pageState.selectedFolderTitle || this.getFolderTitle(folderId),
            pageError: pageState.pageError || '',
            searchValue: pageState.searchValue || ''
        });

        return true;
    }

    loadFolders = () => {
        this.setState({ pageLoading: true, pageError: '', pages: [], selectedFolderTitle: '' });

        axios.get(getBuyerUrl(buyerJiraConfluenceFolderList), getBuyerHeaders())
            .then(response => {
                this.setState({
                    folders: response?.data?.data?.filter(item => item?.id) || [],
                    pageLoading: false
                });
            })
            .catch(error => this.setApiError(error, 'Help folders are not available.'));
    }

    loadPages = () => {
        const folderId = this.getFolderId();

        this.setState({
            pageLoading: true,
            searchValue: '',
            pageError: '',
            pages: [],
            selectedFolderTitle: this.getFolderTitle(folderId)
        });

        axios.get(getBuyerUrl(`${buyerJiraConfluencePageList}${folderId}`), getBuyerHeaders())
            .then(response => {
                this.setState({
                    pages: response.data?.data || [],
                    selectedFolderTitle: response.data?.data[0]?.foldername,
                    pageLoading: false
                });
            })
            .catch(error => {
                this.setState({ pages: [] });
                this.setApiError(error, 'No articles found for this folder.');
            });
    }

    loadSearchData = () => {
        const folderId = this.getFolderId();
        const searchValue = String(this.state.searchValue || '').trim();

        if (!searchValue) {
            this.loadPages();
            return;
        }

        const data = {
            data: {
                searchtext: searchValue
            }
        };

        this.setState({ searchLoading: true, pageError: '' });

        axios.post(getBuyerUrl(`${buyerJiraConfluenceSearchPageView}${folderId}`), JSON.stringify(data), getBuyerHeaders())
            .then(response => {
                const pages = response.data?.data || [];

                this.setState({
                    pages,
                    selectedFolderTitle: this.getFolderTitle(folderId),
                    pageError: pages.length ? '' : `No results found for "${searchValue}".`,
                    searchLoading: false
                });
            })
            .catch(error => this.setApiError(error, 'Search failed. Please try again.'));
    }

    setSearchValue = (searchValue) => {
        this.setState({ searchValue });
    }

    handleSearchKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            this.loadSearchData();
        }
    }

    handleSearchSubmit = (event) => {
        event.preventDefault();
        this.loadSearchData();
    }

    getFolderTitle = (folderId) => {
        const routeTitle = this.props.location?.state?.selectedFolderTitle;
        const folder = this.state.folders.find(item => String(item.id) === String(folderId));
        const storedTitle = this.getStoredFolderTitle(folderId);

        return routeTitle || folder?.title || storedTitle || 'Help Center Articles';
    }

    getStoredFolderTitle = (folderId) => {
        try {
            const storedTitles = JSON.parse(sessionStorage.getItem(FAQ_FOLDER_TITLE_STORAGE_KEY) || '{}');

            return storedTitles[String(folderId)];
        } catch (error) {
            return '';
        }
    }

    setStoredFolderTitle = (folder) => {
        if (!folder?.id || !folder?.title) {
            return;
        }

        try {
            const storedTitles = JSON.parse(sessionStorage.getItem(FAQ_FOLDER_TITLE_STORAGE_KEY) || '{}');
            sessionStorage.setItem(FAQ_FOLDER_TITLE_STORAGE_KEY, JSON.stringify({
                ...storedTitles,
                [String(folder.id)]: folder.title
            }));
        } catch (error) {
            sessionStorage.setItem(FAQ_FOLDER_TITLE_STORAGE_KEY, JSON.stringify({
                [String(folder.id)]: folder.title
            }));
        }
    }

    openFolder = (folder) => {
        if (folder?.type === 'external-link') {
            if (folder?.url) {
                window.open(folder.url, '_blank', 'noopener,noreferrer');
            }

            return;
        }

        if (!folder?.id) {
            return;
        }

        this.setStoredFolderTitle(folder);
        this.props.history.push(`${FAQ_BASE_PATH}/folder/${folder.id}`, { selectedFolderTitle: folder.title });
    }

    openPage = (page) => {
        const pageId = page?.id || page?.contentId || page?.content_id || page?.pageId;

        if (!pageId) {
            return;
        }

        const { searchValue, pages, selectedFolderTitle, pageError } = this.state;
        this.props.history.push(`${FAQ_BASE_PATH}/article/${pageId}`, {
            returnTo: this.props.location.pathname,
            returnState: {
                pages,
                selectedFolderTitle,
                pageError,
                searchValue
            }
        });
    }

    render() {
        if (this.state.errorpageredirect) {
            return <NoData {...this.props} type={this.state.errorType} />;
        }

        const showSearch = this.props.location.pathname.startsWith(`${FAQ_BASE_PATH}/folder`);

        return (
            <div className="faq-help-page">
                {showSearch && (
                    <form className="search-box" onSubmit={this.handleSearchSubmit}>
                        <div className="help-input-group">
                            <button
                                type="submit"
                                className="d-flex input-group-append align-items-center clickable search-icon"
                                aria-label="Search articles"
                            >
                                <i className="fas fa-search" />
                            </button>
                            <input
                                className="form-control help-search-input"
                                id="buyer-help-search"
                                aria-label="Search articles"
                                placeholder="Search articles"
                                value={this.state.searchValue}
                                onChange={(event) => this.setSearchValue(event.target.value)}
                                onKeyDown={this.handleSearchKeyDown}
                            />
                        </div>
                        <Button  variant="secondary" className="search-button ml-3" onClick={()=> this.loadSearchData()}>
                            Search
                        </Button>
                    </form>
                )}
                {this.state.pageLoading || this.state.searchLoading ? (
                    <div className="loader d-flex align-items-center justify-content-center" style={{ height: '100%' }}>
                        <img src={`${process.env.PUBLIC_URL}/static/icons/table/option_1.gif`} alt="Please wait ....." height="100px" width="100px" />
                    </div>
                ) : (
                    <BuyerFAQFolderList
                        history={this.props.history}
                        basePath={FAQ_BASE_PATH}
                        folderId={this.getFolderId()}
                        folders={this.state.folders}
                        pages={this.state.pages}
                        selectedFolderTitle={this.state.selectedFolderTitle}
                        pageError={this.state.pageError}
                        onFolderClick={this.openFolder}
                        onPageClick={this.openPage}
                    />
                )}
            </div>
        );
    }
}

export default connect(state => state)(buyerFaq);
